import React, { useState, useEffect } from 'react';
import { 
  Dialog, Container, Button, DialogActions, DialogContent, 
  DialogTitle, TextField, Box, useMediaQuery, useTheme 
} from '@mui/material';
import { MenuInicial } from "./MenuInicial";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL, USERLIST, USERACTUALIZAR } from '../services/apiConfig';
import { DataGrid } from '@mui/x-data-grid';
import Cargando from './utils/Cargando.jsx';
import axios from 'axios';

function UserList() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [editedName, setEditedName] = useState('');
  const [editedPerfil, setEditedPerfil] = useState('');

  const userData = JSON.parse(sessionStorage.getItem("userData") || '{}');
  const perfil = userData?.perfil;
  const jwtoken = sessionStorage.getItem("authToken");

  const columns = [
    { field: 'id', headerName: 'ID', width: 70 },
    { field: 'username', headerName: 'Usuario', width: 200 },
    { field: 'email', headerName: 'Email', width: 300 },
    { field: 'request_time', headerName: 'Fecha', width: 250 },
    { field: 'perfil', headerName: 'Perfil', width: 80 },
    {
      field: 'actions',
      headerName: 'Acciones',
      width: 150,
      renderCell: (params) => (
        <Button variant="outlined" onClick={() => handleEdit(params.row)}>Editar</Button>
      ),
    },
  ];

  useEffect(() => {
    if (!jwtoken) {
      navigate("/login");
      return;
    }

    if (Number(perfil) !== 1) {
      navigate("/dashboard");
      return;
    }
    
    fetchUsers();
  }, []);

  const fetchUsers = () => {
    setLoading(true);
    const token = sessionStorage.getItem("authToken");
    
    axios.get(API_BASE_URL + USERLIST, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    .then((response) => {
      setUsers(Array.isArray(response.data) ? response.data : []);
      setLoading(false);
    })
    .catch((error) => {
      console.error('Error al cargar los usuarios', error);
      if (error.response?.status === 401) {
        navigate("/login");
      }
      setLoading(false);
    });
  };



  const handleEdit = (user) => {
    setSelectedUser(user);
    setEditedName(user.username);
    setEditedPerfil(user.perfil);
    setIsEditDialogOpen(true);
  };

  const handleSaveEdit = () => {
    const updatedUserData = {
      id: selectedUser.id,
      name: editedName,
      perfil: editedPerfil,
    };
  
    // IMPORTANTE: También enviar Token al actualizar
    axios.post(API_BASE_URL + USERACTUALIZAR, updatedUserData, {
      headers: { 'Authorization': `Bearer ${jwtoken}` }
    })
    .then((response) => {
      setIsEditDialogOpen(false);
      fetchUsers(); // Refrescar la tabla
    })
    .catch((error) => {
      console.error('Error al guardar:', error);
    });
  };

   return (
    <Container maxWidth={isMobile ? false : "xl"} sx={{ px: isMobile ? 1 : 3 }}>
      <MenuInicial />
      <Box sx={{ my: 3 }}>
        <h2>Usuarios</h2>
        <div style={{ height: 500, width: '100%' }}>
          {loading ? (
            <Cargando />
          ) : (
            <DataGrid 
              rows={users} 
              columns={columns} 
              pageSize={10}
              getRowId={(row) => row.id} 
            />
          )}
        </div>
      </Box>

      <Dialog open={isEditDialogOpen} onClose={() => setIsEditDialogOpen(false)}>
        <DialogTitle>Editar Usuario</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Nombre"
            value={editedName}
            onChange={(e) => setEditedName(e.target.value)}
            fullWidth
          />
          <TextField
            margin="dense"
            label="Perfil"
            value={editedPerfil}
            onChange={(e) => setEditedPerfil(e.target.value)}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsEditDialogOpen(false)}>Cancelar</Button>
          <Button onClick={handleSaveEdit} color="primary" variant="contained">Guardar</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default UserList;